import { render, staticRenderFns } from "./UnifiedNavBar.vue?vue&type=template&id=45e67618&scoped=true"
import script from "./UnifiedNavBar.vue?vue&type=script&lang=js"
export * from "./UnifiedNavBar.vue?vue&type=script&lang=js"
import style0 from "./UnifiedNavBar.vue?vue&type=style&index=0&id=45e67618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e67618",
  null
  
)

export default component.exports